
import Vue  from 'vue'
import axios from "axios";
import DentalImageEditorVueComponent from './DentalImageEditor.vue'
import DentalTreatmentItem, {DentalTreatmentItemRef } from './DentalTreatmentItem.vue'
import {AddFormPopupRef} from '../shared/AddFormPopup.vue'
import {PatientDocumentationPopupRef} from '../PatientDocumentationPopup.vue'
import DeleteReasonPopup, { DeleteReasonPopupRef } from "../shared/DeleteReasonPopup.vue";
import html2canvas from 'html2canvas'

import { required, required_if, confirmed, length, email, max } from "vee-validate/dist/rules";
import { extend, ValidationObserver, ValidationProvider} from "vee-validate";
import { DentalLog, DentalLogStatus, DentalLogFilterType, 
        KeyValuePairOfIntegerAndString, 
      WaitlistTreatment, DentalCondition, DentalToothMarkingInfo, 
      DentalToothMarkings, DentalSurfaceLookup, PermissionType, Reason, DeleteReasonType, DeleteReasonEntityType, Patient } from '../../../types/Sapphire_dto';
import Swal, {SweetAlertOptions} from 'sweetalert2';
import { BTable, BCard, BOverlay, BIcon, BButton, BModal, BContainer, BNavbar, BCollapse } from 'bootstrap-vue';
import { guid } from '@fullcalendar/core';

extend("required", {
    ...required,
    message: "This field is required."
});

extend("required_if", {
    ...required_if,
    message: "This field is required!"
});

extend("email", {
  ...email,
  message: "This field must be a valid email."
});

extend("confirmed", {
  ...confirmed,
  message: "This field confirmation does not match."
});

extend("length", {
  ...length,
  message: "This field must have 2 options."
});

extend("max", {
  ...max,
  message:  "This field cannot be longer than 1000 characters."
});


export default Vue.extend({
  name: "dental-session-vue-component",
  components: {
    DentalImageEditorVueComponent,
    DentalTreatmentItem,
    DeleteReasonPopup,
    ValidationProvider
  },
  props: {
      patientID: Number,
      Number: String
  },
  data: function() {
    return {
      selectAll: false,
      newConditionDate: '',
      DentalLogFilterType,
      PermissionType,
      permissions: [] as PermissionType[],
      patientList: [] as KeyValuePairOfIntegerAndString[],
      isSA: false,
      printPdfFlag: false,
      dentalTypeSelected: 99,
      dentalTypeOptions: [{ text: 'All', value: 99 }, { text: 'Waitlist', value: 0 }, { text: 'Treatment', value: 1 }, { text: 'Condition', value: 2}],
      expanded: true,
      showOverlay: false,
      // currentItem: new Object() as DentalLog,
      // currentToothMarkings: new Object() as ToothMarkings,
      changesHaveBeenMade: false,
      sessionID: 0,
      fullTreatmentList: [] as DentalLog[],
      distinctCompletedSessionList: [],
      missingTeethList: [],
      dentalConditionList: [] as DentalCondition[],
      toothNotationList: [],
      selectedTeeth: [] as KeyValuePairOfIntegerAndString[],
      dentalToothList: [] as KeyValuePairOfIntegerAndString[],
      toothNotes: [],
      quickNote: '',
      toothMarkingsList: [] as DentalToothMarkings[],
      treatmentPerPage: 10,
      treatmentCurrentPage: 1,
      treatmentRowCount: 0,
      AllCount: 0,
      PreExistingCount: 0,
      OnWaitlistCount: 0,
      CompletedCount: 0,
      ConditionCount: 0,
      inactiveCount: 0,
      treatment_SortBy: "LogItemDate",
      treatment_SortDesc: true,
      toothNote_SortBy: "CreatedOn",
      toothNote_SortDesc: true,
      dentalCondition_SortBy: "CreatedOn",
      dentalCondition_SortDesc: true,
      selectedSessionID: 0,
      selectedLogFilterID: DentalLogFilterType.All,
      dateFilterFrom: "",
      dateFilterTo: "",
      selectedTeethFilter: [] as KeyValuePairOfIntegerAndString[],
      showXrayBtn: false,
      deleteReasons: [] as Reason[],
      selectedReasons: [] as Reason[],
      selectedConditionDate: new Date(),
      selectedCondition: new Object() as DentalLog,
      PatientDetails: new Object() as Patient,
      treatmentFields: [
        {
          key: "LogTypeName",
          label: "Type",
          sortable: true,
        },
        {
          key: "LogItemDate",
          label: "Date",
          sortable: true,
          formatter: (value: any, key: any, item: { LogType: any; }) => {
            return getFormattedDate(value, item.LogType);
          },
        },
        {
          key: "ToothName",
          label: "Tooth",
          sortable: true,
        },
        {
          key: "waitlistTreatment.NAME",
          label: "Treatment/Condition",
          sortable: true,
        },
        {
          key: "LOC_Desc",
          label: "LOC",
          sortable: true,
        },
        {
          key: "CreatedByName",
          label: "Created By",
          sortable: true,
        },
        {
          key: "DC_Reason_Note",
          label: "Reason Note"
        },
        {
          key: "DCReasonByName",
          label: "Deleted Reason",
          sortable: true
        },
        {
          key: "DC_By",
          label: "Deleted By",
          sortable: true
        },
        {
          key: "DC_Date",
          label: "Deleted Date",
          sortable: true,
          formatter: (value: any, key: any, item: { LogType: any; }) => {
            return getFormattedDate(value, item.LogType);
          },
        },
        { key: "actions" },
      ],
      toothNoteFields: [
        {
          key: "ToothName",
          label: "Tooth",
          sortable: true,
        },
        {
          key: "CreatedOn",
          label: "Date",
          sortable: true,
          formatter: (value: any) => {
            return getFormattedDate(value, 1);
          },
        },
        {
          key: "CreatedByName",
          label: "Created By",
          sortable: true,
        },
        {
          key: "Note",
          label: "Note",
          sortable: true,
        },
        {
          key: "Active",
          label: "Active",
          sortable: true,
        },
        { key: "actions", label: "Actions" },
      ],
      dentalConditionFields: [
        {
          key: "ToothID",
          label: "Tooth",
          sortable: true,
        },
        {
          key: "CreatedOn",
          label: "Date",
          sortable: true,
          formatter: (value: any) => {
            return getFormattedDate(value, 1);
          },
        },
        {
          key: "CreatedByName",
          label: "Created By",
          sortable: true,
        },
        {
          key: "ConditionTypeName",
          label: "Name",
          sortable: true,
        },
        {
          key: "Symbol",
          label: "Symbol",
          sortable: true,
        },
        { key: "actions", label: "Actions" },
      ],
      logFilterList: [],
    };
  },
  computed: {
    canCompleteWaitlist(): boolean {
      return (this.isSA || (!this.permissions.includes(PermissionType.CanAccessDentalReadOnly) && this.permissions.includes(PermissionType.CanCompleteWaitlists)));
    },
    CanDeleteDentalTreatments(): boolean {
      return (this.isSA ||  this.permissions.includes(PermissionType.CanDeleteDentalTreatments));
    },
    visibleTreatmentFields(): any {
      const dcFields = ['DC_Reason_Note', 'DCReasonByName', 'DC_By', 'DC_Date' ];
        if (this.selectedLogFilterID != DentalLogFilterType.Inactive) {
          return this.treatmentFields.filter( f => !dcFields.includes(f.key));
        }
        else {
          return this.treatmentFields;
        }
    },
    DeleteReason(): DeleteReasonPopupRef {
      return this.$refs.DeleteReasonPopupVueComponent as DeleteReasonPopupRef;
    },
    AddFormPopup(): AddFormPopupRef {
      return this.$refs.AddFormPopupVueComponent as AddFormPopupRef;
    },
    PatientDocPopup(): PatientDocumentationPopupRef {
      return this.$refs.PatientDocumentationComponent as PatientDocumentationPopupRef;
    },
    DentalTreatmentItemPopup(): DentalTreatmentItemRef {
      return this.$refs.DentalTreatmentItemComponent as DentalTreatmentItemRef;
    },
  },
  watch: {
    patientID: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.clearSelectedRows();
        this.showOverlay = true;
        this.selectedLogFilterID = DentalLogFilterType.All;
        this.dentalTypeSelected = 99;
        this.selectedTeethFilter = [];
        this.printPdfFlag = false;
        await this.refreshSession();
        this.showOverlay = false;
      }
    },
    dateFilterFrom: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.showOverlay = true;
        await this.refreshTreatmentInfo(false);
        this.showOverlay = false;
      }
    },
    dateFilterTo: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.showOverlay = true;
        await this.refreshTreatmentInfo(false);
        this.showOverlay = false;
      }
    },
    selectedLogFilterID: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.showOverlay = true;
        await this.refreshTreatmentInfo(false);
        this.showOverlay = false;
        //console.log('got here', newVal, oldVal);
      }
    },
    dentalTypeSelected: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.showOverlay = true;
        await this.refreshTreatmentInfo(false);
        this.showOverlay = false;
      }
    },
    selectedTeethFilter: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.showOverlay = true;
        await this.refreshTreatmentInfo(false);
        this.showOverlay = false;
      }
    },
    selectedReasons: async function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.showOverlay = true;
        await this.refreshTreatmentInfo(false);
        this.showOverlay = false;
      }
    },
    selectAll: function(newVal, oldVal) {
      if (newVal == true) {
        this.selectAllRows();
      }
      else {
        this.clearSelectedRows();
      }
    },
  },
  mounted: function () {
    this.getDeleteReasons(DeleteReasonType.Waitlist);
  },
  methods: {
    async completeSelected() {
      let selectedLogItems = this.fullTreatmentList.filter(t => t.IsSelected == true);
      if (selectedLogItems.length > 0 ) {
        selectedLogItems.forEach( async dentalItem => {
          if(dentalItem.LogType == DentalLogFilterType.OnWaitlist) {
            dentalItem.waitlistID = dentalItem.ID;
            dentalItem.sessionID = this.sessionID;
            dentalItem.ItemStatus = DentalLogStatus.CompleteWaitlist;
          }
          await this.saveTreatment(dentalItem);
        })
      }
      },
      generateAndUseGUID() {
          const guid = generateGUID();
      },
    deleteSelected() {
      let selectedLogItems = this.fullTreatmentList.filter(t => t.IsSelected == true);
      if (selectedLogItems.length > 0 ) {
        this.DeleteReason.showBulkPopup(this.patientID, selectedLogItems, 'Bulk Delete Dental Treatments', DeleteReasonType.Waitlist, "Selected " + selectedLogItems.length + " rows."  );
      }
    },
    selectAllRows() {
      this.fullTreatmentList.forEach(t => { t.IsSelected = true;});
    },
    clearSelectedRows() {
      this.fullTreatmentList.forEach(t => { t.IsSelected = false;});
    },
    async getDeleteReasons(reasonType) {
        var vm = this;
        await axios
            .post("../../Common/Services/EmarClientOperations.svc/GetDeleteReasons",
                {
                    reasonTypeID: reasonType
                }
        )
        .then((response) => {
        vm.deleteReasons = [];
        vm.deleteReasons = JSON.parse(response.data.d);
        })
        .catch(function() {
        // handle error
        // eslint-disable-next-line no-undef
        // tb_remove2();
        });
    },

    async getPatient() {
        const response = await axios
            .post("../../Common/Services/EmarClientOperations.svc/GetPatientDetails",
                {
                    patientID: this.patientID
                }
        );
        
         this.PatientDetails = JSON.parse(response.data.d);
    },
    
    async PopulateLogList() {
      this.logFilterList.length = 0;
      this.logFilterList.push({ text: "All (" + this.AllCount + ")" , value: "0" });
      this.logFilterList.push({ text: "Pre Existing (" + this.PreExistingCount + ")", value: 1, buttonVariant: "dental-preexisting" });
      this.logFilterList.push({ text: "On Waitlist (" + this.OnWaitlistCount + ")", value: 2, buttonVariant: "danger"});
      this.logFilterList.push({ text: "Completed (" + this.CompletedCount + ")", value: 3, buttonVariant: "primary" });
      this.logFilterList.push({ text: "Condition (" + this.ConditionCount + ")", value: 5, buttonVariant: "offWhite"});
      this.logFilterList.push({ text: "Inactive (" + this.inactiveCount + ")", value: 4, buttonVariant: "dental-inactive" }); 
    },
    async checkFacilityRegion() {
        const response = await axios
            .post("../../../Common/Services/EmarClientOperations.svc/CheckIfPADOC");

        this.showXrayBtn = JSON.parse(response.data.d);
        

    },
    limitTeeth(count: number) {
      return "and " + count + " more";
    },
    limitDCReason(count: number) {
      return "and " + count + " more";
    },
    async getDentalToothList() {
      const response = await axios
        .post("../../../Common/Services/EhrTaskService.svc/GetDentalToothList",
        {
            
        });

      var toothList = JSON.parse(response.data.d);

      var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

      this.dentalToothList = toothList.sort(function (a: { Key: string; }, b: { Key: string; }) {
          return collator.compare(a.Key, b.Key)
      });
    },
    addNote() {
      this.$bvModal.show('DentalQuickNote');
    },
    viewNotes() {
      this.$bvModal.show('modalToothNotes');
    },
    viewConditions() {
      this.$bvModal.show('modalDentalConditions');
    },
    async refreshTreatmentInfo(printPDF) {
      this.printPdfFlag = printPDF;
      await this.getCompletedTreatmentList();
      await this.getToothMarkingsList();
      await this.PopulateLogList();
      
    },
    async refreshSession() {
      await this.getCompletedTreatmentList();
      await this.getDentalSessionDates();
      await this.getMissingToothList();
      await this.getToothMarkingsList();
      await this.getToothNoteList();
      await this.getConditionList();
      await this.getToothNotationList();
      await this.getDentalToothList();
      await this.checkFacilityRegion();
      await this.PopulateLogList();
      await this.getPatient();
    },
    // async getBase64Image(url) {
    //   const response = await fetch(url);
    //   const blob = await response.blob();
    //   const reader = new FileReader();
    //   await new Promise((resolve, reject) => {
    //     reader.onload = resolve;
    //     reader.onerror = reject;
    //     reader.readAsDataURL(blob);
    //   });
    //   return reader.result.replace(/^data:.+;base64,/, '')
    // },
    async onPrintClick() {
      this.showOverlay = true;
      //Need to clear the selected teeth, and reset the filter to "All" for the report.
      this.selectedTeeth = [];
      this.expanded = true;
      await this.refreshTreatmentInfo(true);

//      let canvas = await html2canvas(document.querySelector('#toothChart') );
      let canvas = await html2canvas(document.getElementById('toothChart') );
          //console.log(canvas.toDataURL('image/png'));

     var base64 = canvas.toDataURL('image/png').replace('data:image/png;base64,', '');

      const fd = new FormData(document.forms['patientDentalForm']);
      fd.append('patientId', this.patientID.toString());
      fd.append('FileBase64Str', base64);

      let response = await axios.post("../../../Common/Services/EhrTaskService.svc/GetPatientDentalPDF", fd);         
           // const contentType = 'image/png';
          // const b64Data = 'iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==';
      const contentType = 'application/pdf';
      const b64Data = JSON.parse(response.data.d);
      const blob = b64toBlob(b64Data, contentType);
      var fileURL = window.URL.createObjectURL(blob);
      var fileLink = document.createElement('a');
    
      fileLink.href = fileURL;
      fileLink.setAttribute('download', 'Patient Dental Chart.pdf');
      document.body.appendChild(fileLink);
      fileLink.click();

      this.showOverlay = false;
    },    
    async saveDeleteClick() {
      this.showOverlay = true;
      this.DeleteReason.hidePopup();
        
      await this.refreshSession();
      this.showOverlay = false;
    },
    completeWaitlistItemFromTable(logItem: DentalLog) {
      const SwalWithOptions = Swal.mixin({
        customClass: {
            container: 'swal2-container-vue',
            //content: 'swal2-content-vue',
            popup: 'swal2-popup-vue',
            footer: 'swal2-footer-vue',
            // title: 'swal2-title-vue',
            // cancelButton: 'swal-button-vue',
            // confirmButton: 'swal-button-vue',
            // closeButton: 'swal-button-vue',
        },
      });

      SwalWithOptions.fire({
        title: "Are you sure you want to complete this waitlist?",
        confirmButtonText: 'Save',
        showCancelButton: true,
      } as SweetAlertOptions
      ).then((result) => {

          if(result.isConfirmed) {
            this.showOverlay = true;

            if (logItem.ID > 0) {
              logItem.waitlistID = logItem.ID;
              logItem.sessionID = this.sessionID;
              logItem.ItemStatus = DentalLogStatus.CompleteWaitlist;

              this.saveTreatment(logItem);
            }
            this.showOverlay = false;
          }
      });
    },
    async scheduleWaitlistAppointment(logItem) {
      const response = await axios.post(
        "../../../Common/Services/EhrTaskService.svc/GetSchedApptURL",
        {
          patientID: this.patientID,
          waitlistID: logItem.ID
        }
      );
      
      let ret_response = JSON.parse(response.data.d);
      window.open(ret_response, '_blank');
    },
    async deleteToothNote(toothNoteItem) {
      this.DeleteReason.showPopup(this.patientID, toothNoteItem.ID, 'Delete Tooth Note', DeleteReasonType.Waitlist, toothNoteItem.Note, toothNoteItem.ToothName, DeleteReasonEntityType.DentalToothNote );
    },
    async deleteCondition(conditionItem: DentalCondition) {
      this.DeleteReason.showPopup(this.patientID, conditionItem.ID, 'Delete Condition', DeleteReasonType.Waitlist, conditionItem.ConditionTypeName, conditionItem.ToothName, DeleteReasonEntityType.DentalCondition );
    },
    async editCondition(conditionItem: DentalLog) {
      this.showOverlay= true;
      conditionItem.LogItemDate = this.selectedConditionDate;

      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/EditConditionDate",
          {
            condition: JSON.stringify(conditionItem)
          }
        )

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('DentalConditionEdit');
      });
        
      await this.refreshSession();

      this.showOverlay= false;

    },
    async deleteLogItemFromTable(logItem) {

      if (logItem.ID > 0) {

      let entityDeleteTypeID = DeleteReasonEntityType.DentalTreatment;

      switch (logItem.dentalTypeID) {
        //Waitlists
        case 0: 
          entityDeleteTypeID = DeleteReasonEntityType.Waitlist;
          break;
        //Treatments
        case 1: 
          entityDeleteTypeID = DeleteReasonEntityType.DentalTreatment;
          break;
        //Conditions
        case 2:
          entityDeleteTypeID = DeleteReasonEntityType.DentalCondition;
          break;
       }
        
        this.DeleteReason.showPopup(this.patientID, logItem.ID, 'Delete Dental Treatment', DeleteReasonType.Waitlist, logItem.TreatmentName, logItem.ToothName, entityDeleteTypeID );
      }
    },
    async saveTreatment(dentalItem: DentalLog) {

      this.showOverlay = true;
      let toothList = dentalItem.selectedTeeth.map(function(val: { Key: any; }) { return val.Key; }).join(',');


      if (dentalItem.LocID == 0) {
        dentalItem.LocID = dentalItem.Loc.Key;
      }
      // if (dentalItem.ConditionID == 0) {
      //   dentalItem.ConditionID = dentalItem.Condition.Key;
      // }

      const response = await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/SetSaveDentalTreatment",
          {
            teeth: toothList,
            treatmentItem: JSON.stringify(dentalItem),
            toothMarkings: JSON.stringify(dentalItem.ToothMarkings)
          }
        )

      let ret_dentalLog = JSON.parse(response.data.d);

      this.sessionID = ret_dentalLog.sessionID;
      this.DentalTreatmentItemPopup.hide();
      this.selectedTeeth = [];
        
      await this.refreshSession();
      this.showOverlay = false;
    },
    resetQuickNoteModal() {
      this.quickNote = '';
      (this.$refs.quickNoteForm as InstanceType<typeof ValidationObserver>).reset();
     },
    async saveNewNote() {
      this.showOverlay = true;

      if (this.selectedTeeth.length == 0 ) {
        axios.post(
          "../../../Common/Services/EhrTaskService.svc/SetAddDentalToothNote",
          {
            patientID: this.patientID,
            toothID: 0,
            quickNote: this.quickNote
          }
        );
      } else {
        await this.selectedTeeth.forEach((tooth: { Key: any; }) => {
          axios.post(
            "../../../Common/Services/EhrTaskService.svc/SetAddDentalToothNote",
            {
              patientID: this.patientID,
              toothID: tooth.Key,
              quickNote: this.quickNote
            }
          );
        });
      }

      //TFS 20579:  Clear the tooth selections after adding a Quick Note.
      this.selectedTeeth = [];

      await this.refreshSession();

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('DentalQuickNote')
      });
      this.showOverlay = false;
    },
    async getToothNoteList() {

      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/GetToothNoteList",
          {
            patientID: this.patientID,
          }
        )
        .then((response) => {
          this.toothNotes = [];
            this.toothNotes = JSON.parse(response.data.d);
        })
        .catch(function() {
        });
    },
    addNewTreatment() {
        this.showOverlay = true;
        let FilterType: DentalLogFilterType = DentalLogFilterType.OnWaitlist;
        if ([DentalLogFilterType.PreExisting, DentalLogFilterType.CompletedTreatment].includes(this.selectedLogFilterID))
          FilterType = this.selectedLogFilterID;
        
        let filterStatus: DentalLogStatus = DentalLogStatus.NewWaitlist;
        if (this.selectedLogFilterID == DentalLogFilterType.PreExisting)
          filterStatus =  DentalLogStatus.PreExisting;
          if (this.selectedLogFilterID == DentalLogFilterType.CompletedTreatment)
          filterStatus =  DentalLogStatus.CompleteTreatment;

      var preselectedList = [] as KeyValuePairOfIntegerAndString[];
      this.selectedTeeth.forEach((tooth: KeyValuePairOfIntegerAndString) => preselectedList.push(tooth));

      let currentToothMarkings: DentalToothMarkings = {
        ToothID: 0,
        ID: 0,
        RightInfo: this.addNewInfo(),
        LeftInfo: this.addNewInfo(),
        TopInfo: this.addNewInfo(),
        BottomInfo: this.addNewInfo(),
        CenterInfo: this.addNewInfo(),
        Session_Date: undefined,
        WaitlistID: 0,
        DentalTreatmentID: 0,
        patientID: 0,
        InactiveFlag: false
      };

      let treatment: DentalLog = {
        ID: 0,
        IsSelected: false,
        sessionID: this.sessionID,
        patientID: this.patientID,
        LogType: FilterType,
        toothID: 0,
        LocID: 0,
        waitlistID: 0,
        LogItemDate: new Date(),
        selectedTeeth: preselectedList,
        waitlistTreatment: new Object as WaitlistTreatment,
        ToothMarkings: currentToothMarkings,
        Loc: new Object as KeyValuePairOfIntegerAndString,
        dentalTypeID: 1,
        ConditionID: 0,
        ToothName: '',
        Stamp: '',
        ItemStatus: filterStatus,
        Condition: undefined,
        treatmentStatusID: 0,
        diagnosisID: 0,
        waitlistProcedureID: 0,
        ModifiedBy: 0,
        ModifiedOn: undefined,
        CreatedBy: 0,
        CreatedOn: undefined,
        DC_Date: undefined
      };
      this.showOverlay = false;
      
      this.DentalTreatmentItemPopup.show(treatment, "Add Item");
    },
    addNewInfo(): DentalToothMarkingInfo {
      let info: DentalToothMarkingInfo = {
        TreatmentName: '',
        StatusID: 0,
        AssocDate: new Date(),
        SurfaceLookup: DentalSurfaceLookup.Mesial
      }
      return info;
    },
    editItem(dentalLogItem: DentalLog) {
      if (dentalLogItem.LogType == DentalLogFilterType.Condition) {
        this.selectedCondition = dentalLogItem;
        this.selectedConditionDate = dentalLogItem.LogItemDate;
        this.$bvModal.show('DentalConditionEdit');
      }
      else {
        this.DentalTreatmentItemPopup.show(dentalLogItem, "Edit Item");
      }
    },
    async getCompletedTreatmentList() {
      const response = await axios.post(
        "../../../Common/Services/EhrTaskService.svc/GetPatientDentalLog",
        {
          patientID: this.patientID,
          sortBy: this.treatment_SortBy,
          sortOrder: this.treatment_SortDesc,
          logFilterTypeID: this.printPdfFlag ? 0 : this.selectedLogFilterID,
          dateFilterFrom: this.dateFilterFrom,
          dateFilterTo: this.dateFilterTo,
          selectedType: this.dentalTypeSelected,
          selectedTeethFilter: this.selectedTeethFilter.length > 0 ? this.selectedTeethFilter.map((obj: { Key: any; }) => obj.Key).join(', ') : '',
          selectedDCReasonFilter: this.selectedReasons.length > 0 ? this.selectedReasons.map((obj: { ReasonID: any; }) => obj.ReasonID).join(', ') : ''
        }
      );
      
      let ret_response = JSON.parse(response.data.d);

      this.treatmentRowCount = ret_response.totalRows;
      this.AllCount = ret_response.AllCount;
      this.PreExistingCount = ret_response.PreExistingCount;
      this.OnWaitlistCount = ret_response.OnWaitlistCount;
      this.CompletedCount = ret_response.CompletedCount;
      this.ConditionCount = ret_response.ConditionCount;
      this.inactiveCount = ret_response.InactiveCount;
      this.permissions = ret_response.permissions;
      this.isSA = ret_response.isSA;
      this.fullTreatmentList = ret_response.items || [];
      return this.fullTreatmentList;
      
    },
    async reactivateDeletedItem(dentalLogItem: DentalLog, logFilterType: DentalLogFilterType) {
      this.showOverlay = true;

      if (logFilterType == DentalLogFilterType.OnWaitlist) {
        axios.post(
          "../../../Common/Services/EhrTaskService.svc/SetReactivateDiscontinuedWaitlist",
          {
            patientID: this.patientID,
            waitlistID: dentalLogItem.ID
          }
        );
        } else {
          axios.post(
            "../../../Common/Services/EhrTaskService.svc/SetReactivateDiscontinuedTreatment",
            {
              patientID: this.patientID,
              treatmentID: dentalLogItem.ID
            }
          );
      }
      await this.refreshSession();

      this.showOverlay = false;
    },
    async getToothMarkingsList() {
      await axios.post(
        "../../../Common/Services/EhrTaskService.svc/GetPatientDentalToothMarkings",
        {
          patientID: this.patientID,
          dateFilterFrom: this.dateFilterFrom,
          dateFilterTo: this.dateFilterTo,
          logFilterTypeID: this.selectedLogFilterID,
        }
      ).then((response) => {
          this.toothMarkingsList = [];
          this.toothMarkingsList = JSON.parse(response.data.d);
        })
       .catch(function() {
          // handle error
          // eslint-disable-next-line no-undef
          // tb_remove2();
        });
    },
    async getDentalSessionDates() {
      // Load the Session Drop down with current Session Dates for this patient.
      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/GetDentalSessionDates",
          {
            patientID: this.patientID,
          }
        )
        .then((response) => {
          this.distinctCompletedSessionList = JSON.parse(response.data.d);
        })
        .catch(function() {
          // handle error
          // eslint-disable-next-line no-undef
          // tb_remove2();
        });
      },
    async getMissingToothList() {
      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/GetMissingToothList",
          {
            patientID: this.patientID,
          }
        )
        .then((response) => {
            this.missingTeethList = JSON.parse(response.data.d);
        })
        .catch(function() {
        });
    },
    async getConditionList() {
      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/GetDentalConditionList",
          {
            patientID: this.patientID,
          }
        )
        .then((response) => {
            this.dentalConditionList = JSON.parse(response.data.d);
        })
        .catch(function() {
        });
    },
    async getToothNotationList() {
      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/GetToothNotationList",
          {
            patientID: this.patientID,
          }
        )
        .then((response) => {
            this.toothNotationList = JSON.parse(response.data.d);
        })
        .catch(function() {
        });
    },
    showAddFormPopup() {
      this.AddFormPopup.show(this.patientID, '', '4');
    },
    showPatientDocPopup() {
      this.PatientDocPopup.show(this.patientID, '', '4');
    },
    async showDocumentation() {
      let userTypes = [4];
      let response = await axios
        .post(
          "../../../Common/Services/EmarClientOperations.svc/GetPatientChartNavigatorURL",
          {
            patientID: this.patientID,
            userTypeIDs: userTypes
          }
        );
            
      let navURL = response.data.d;
      window.open(navURL, '_blank');
      },

      async viewDentalImages() {

          // let navURL = 'https://dental.cor.pa.gov/XVWeb/';
          // window.open(navURL, '_blank');
          // Configuration settings
          const url = "https://dentalweb.cor.pa.gov/MiMedicalViewer/#/login/auto/plain/";

          // Get number of seconds since 1/1/1970 (Unix timestamp)
          const uTime = Math.floor(Date.now() / 1000);

         // this.generateAndUseGUID()
          const tokenID = generateGUID();

          // Construct the patient data object
          const dentalImagePatient = {
              authenticationCookie: '',
              email: '',
              phoneNumber: '',
              impersonate: '%SYSLOGIN%',
              user: 'Dental',
              pass: 'L00$3t00th23',
              role: null,
              created: uTime,
              cmd: 'ShowPatient',
              tokenId: tokenID,
              p: {
                  patientID: this.PatientDetails.Number,
                  style: 'medicor',
                  dentalMode: true,
                  toolbars: '',
                  seriesInstanceUID: '',
                  isStructuredDisplay: '0',
                  requireAuthentication: false
              }

          };
          const json = JSON.stringify(dentalImagePatient);
          const encodedJson = encodeURIComponent(json);
          const finalUrl = `${url}${encodedJson}`;
          window.open(finalUrl, '_blank');
      },

    async SelectRemainingTeeth(begin: number, end: number) {
      var AllRemaining = [] as KeyValuePairOfIntegerAndString[];
      this.selectedTeeth = [];
      for (var i = begin; i <= end; i++) {
          if (!this.missingTeethList.some((c: { Key: any; }) => c.Key === i)) {
              AllRemaining.push({Key: i, Value: i.toString()});
          }
      }
      this.selectedTeeth = AllRemaining;
    },
    async clearSelectedTeeth() {
        this.selectedTeeth = [];
    },
    onToothSelected(toothID: number) {
        var index = this.selectedTeeth.findIndex((t: { Key: any; }) => t.Key === toothID);

        if (index > -1) {
          this.selectedTeeth.splice(index, 1);
        } else {
            this.selectedTeeth.push({Key: toothID, Value: toothID.toString()});
        }
    },
    filterStatus(statusID: number) {
      this.selectedLogFilterID = statusID;
    },
    async addCommonCondition(condID: number, surfaceID: number) {
      this.showOverlay = true;

      await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/SetSaveCommonCondition",
          {
            patientID: this.patientID,
            sessionID: this.sessionID,
            teeth: this.selectedTeeth.map(function(val: { Key: any; }) { return val.Key; }).join(','),
            conditionID: condID,
            surfaceID: surfaceID
          }
        )

      this.selectedTeeth = [];
        
      await this.refreshSession();
      this.showOverlay = false;
    },
    async addCommonTreatment(treatmentID: number, surfaceID: number, defaultToothID: number) {
      this.showOverlay = true;
      let toothList = [] as KeyValuePairOfIntegerAndString[];
      if (defaultToothID > 0) {
        toothList.push({Key: defaultToothID, Value: defaultToothID.toString()});
      } else {
        toothList = this.selectedTeeth;
      }

      const response = await axios
        .post(
          "../../../Common/Services/EhrTaskService.svc/SetSaveCommonTreatment",
          {
            patientID: this.patientID,
            sessionID: this.sessionID,
            teeth: toothList.map(function(val) { return val.Key; }).join(','),
            treatmentID: treatmentID,
            surfaceID: surfaceID,
            statusID: this.selectedLogFilterID
          }
        )

      let ret_dentalLog = JSON.parse(response.data.d);
      this.sessionID = ret_dentalLog.sessionID;
      this.selectedTeeth = [];
        
      await this.refreshSession();
      this.showOverlay = false;
    },
  },
});

function b64toBlob(b64Data: string, contentType='', sliceSize=512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
    }

    function generateGUID() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (
            S4() +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            '-' +
            S4() +
            S4() +
            S4()
        );
    }


function getFormattedDate(value: string | number | Date, logTypeID: number) {
  var d = new Date(value);
  var minDate = new Date('01/01/0001');
  if (!(d > minDate)) {
    return '';
  }

  var month = "" + (d.getMonth() + 1);
  var day = "" + d.getDate();
  var year = "" + d.getFullYear();

  //var hours = d.getHours();
  //var minutes = d.getMinutes();
  //var meridiem = d.getHours() > 12 ? "pm" : "am";

  //hours = hours % 12;
  //hours = hours ? hours : 12; // the hour '0' should be '12'
  //minutes = minutes < 10 ? "0" + minutes : minutes;

  //let timePart = "" + hours + ":" + minutes + " " + meridiem;

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  let dayPart = [month, day, year].join("/");

  let returnDate = dayPart;

  //Let's not send back the time part for Waitlist rows in the Log Table.
  if (logTypeID == 2) {
    returnDate = dayPart;
  }

  return returnDate;
}
